import { LoadingService } from "./../services/loading.service";
import { UserProfileService } from "./../services/user.service";
import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";
import { BehaviorSubject, Observable, throwError } from "rxjs";
import {
  catchError,
  filter,
  finalize,
  switchMap,
  take,
  timeout,
} from "rxjs/operators";
import { AuthenticationService } from "../services/auth.service";
import Swal from "sweetalert2";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private refreshTokenInProgress = false;
  private refreshTokenSubject = new BehaviorSubject(null);
  private holding_requests = new BehaviorSubject<any[]>([]);

  constructor(
    private authenticationService: AuthenticationService,
    private auth_service: UserProfileService,
    private loading_service: LoadingService
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        // console.log('err :', err);
        // console.log("Intercepting error", err.error.error.message);
        if (err.status === 401 && err.error.error.message) {
          if (
            err.error.error.message == "INVALID_TOKEN" ||
            err.error.error.message == "TOKEN_EXPIRED"
          ) {
            if (this.refreshTokenInProgress) {
              // console.log("refresh progress request on hold");
              return this.refreshTokenSubject.pipe(
                filter((result) => result),
                take(1),
                switchMap(() =>
                  next.handle(this.addAuthToken(request, "holded"))
                )
              );
            } else {
              this.refreshTokenInProgress = true;
              this.refreshTokenSubject.next(null);
              this.loading_service.remove_all();
              return this.auth_service.int_refreshToken().pipe(
                switchMap((response) => {
                  this.auth_service.push_auth(response.data);
                  let token = response.data.accessToken;
                  this.refreshTokenSubject.next(token);
                  return next.handle(this.addAuthToken(request, "first"));
                }),
                finalize(() => (this.refreshTokenInProgress = false))
              );
            }
          } else {
            return throwError(() => new Error(err));
          }
        }
        else if (err.status === 403 && err?.error?.error?.message) {
          if (
            err.error.error.message == "NOT_ALLOWED"
          ) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: err.error.error.message,
            });
          }
          if (err.error.errore.message == "CANNOT_EDIT_JOB") {
            err.handled = true;
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: err.error.error.message,
            });
            return throwError(err)
          }
        }
        else if (err.status === 409 && err.error.error.message) {
          if (
            err.error.error.message == "DEVICE_REGISTERED"
          ) {
            // Swal.fire("error", "Your file has been deleted.", "success");

            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: err.error.error.message,
            });
          }
        } else if (err.status === 422 && err.error.error.message) {
          if (
            err.error.error.message == "EMAIL_EXISTS"
          ) {
            err.handled = true;
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: err.error.error.message,
            });
            return throwError(err)
          }
        }

        else {
          return throwError(() => { new Error(err) });
        }
      })
    );
  }

  addAuthToken(request: HttpRequest<any>, request_from: string) {
    // console.log("cloning request from " + request_from);
    let token = this.auth_service.get_token();
    if (!token) {
      return request;
    }
    // console.log("with token " + token);

    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
}
